import { Explicacao } from '../../components/Explicacao'
import { TEXTOS } from '../../lib/glossario'
import type { LinhaPorSetor } from '../../types/repositorios'
import { EtiquetaDeSetor } from './EtiquetaDeSetor'

const INTEIRO = new Intl.NumberFormat('pt-BR')

const CELULA = 'px-3 py-2 text-right tabular-nums text-slate-700'

/**
 * Uma linha por setor: quem está mexendo no código que o contrato sustenta.
 *
 * A coluna "citam solicitação" vem ao lado de "commits" de propósito: é a razão entre as duas que
 * responde a pergunta do fiscal — quanto do trabalho passou pelo processo de mudança.
 *
 * @param props as linhas
 * @returns a tabela
 */
export function TabelaPorSetor({ linhas }: { linhas: LinhaPorSetor[] }) {
  const t = TEXTOS.repositorios
  if (linhas.length === 0) {
    return null
  }
  return (
    <section className="cartao overflow-x-auto" aria-label={t.secoes.setores}>
      <h2 className="px-4 pt-4 text-base font-semibold text-slate-900">{t.secoes.setores}</h2>
      <table className="mt-2 min-w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-xs font-semibold text-slate-500">
            <th className="px-3 py-2">{t.pessoas.colunas.pessoa}</th>
            <th className="px-3 py-2 text-right">{t.numeros.autores}</th>
            <th className="px-3 py-2 text-right">{t.numeros.commits}</th>
            <th className="px-3 py-2 text-right">{t.numeros.comSolicitacao}</th>
            <th className="px-3 py-2 text-right">
              <span className="inline-flex items-center gap-1">
                {t.numeros.integracoes}
                <Explicacao termo="integracao" />
              </span>
            </th>
            <th className="px-3 py-2 text-right">{t.pessoas.colunas.linhas}</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((linha) => (
            <tr key={linha.setor} className="border-b border-slate-100 last:border-0">
              <td className="px-3 py-2">
                <EtiquetaDeSetor setor={linha.setor} />
              </td>
              <td className={CELULA}>{INTEIRO.format(linha.autores)}</td>
              <td className={`${CELULA} font-semibold text-slate-900`}>{INTEIRO.format(linha.commits)}</td>
              <td className={CELULA}>
                {INTEIRO.format(linha.comSolicitacaoCitada)}
                {linha.commits > 0 && (
                  <span className="ml-1 text-xs text-slate-500">({Math.round((100 * linha.comSolicitacaoCitada) / linha.commits)}%)</span>
                )}
              </td>
              <td className={CELULA}>{INTEIRO.format(linha.integracoes)}</td>
              <td className={CELULA}>
                +{INTEIRO.format(linha.adicoes)} / −{INTEIRO.format(linha.remocoes)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
